// src/config/api.ts
const env = process.env.REACT_APP_ENV || 'local';

export const api = {
  env,

  auth2: process.env.REACT_APP_AUTH2_API_URL!,
  technfe: process.env.REACT_APP_TECHNFE_API_URL!,
  techfood: process.env.REACT_APP_TECHFOOD_API_URL!,
  techspdv: process.env.REACT_APP_TECHSPDV_API_URL!,
  technfservico: process.env.REACT_APP_TECHNFSERVICO_API_URL!,
};

// Debug no console
console.log(`%c Ambiente atual → ${env.toUpperCase()}`, 'color: orange; font-weight: bold');